<template>
  <div
    class="betslip-odds betslip-odds d-flex flex-shrink-0"
    :class="{
      plus: changed_type === 'plus',
      minus: changed_type === 'minus',
      changeClass: wait_for_accept,
    }"
  >
    <span class="odds">
      <span class="plus-icon" v-if="changed_type === 'plus'">
        <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.16782 4.26028L0.839872 1.30211C0.516209 1.01441 0.686439 0.479285 1.11684 0.431463L4.44478 0.0616906C4.74097 0.0287814 5 0.260627 5 0.558632V3.88658C5 4.318 4.49027 4.54691 4.16782 4.26028Z"
            fill="#38AC26"
          />
        </svg>
      </span>
      <span class="minus-icon" v-if="changed_type === 'minus'">
        <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.90692 0.929952L4.35583 4.64866C4.59401 5.01033 4.29108 5.48316 3.86297 5.41796L0.552713 4.9138C0.258105 4.86893 0.0679042 4.57794 0.145034 4.29009L1.00637 1.07554C1.11803 0.658813 1.66964 0.569639 1.90692 0.929952Z"
            fill="#DC3545"
          />
        </svg>
      </span>
      {{ normalizeSpread(line.Point, line.Point) }}
      ({{ convertOdds(line.Odd, selectedOddType) }})
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { convertOdds, normalizeSpread } from './bet-slip-utils';

export default {
  props: ['spread', 'odds', 'changed_type', 'line', 'wait_for_accept'],
  computed: {
    ...mapState('settings', ['selectedOddType']),
  },
  data() {
    return {
      changeClass: '',
    };
  },
  watch: {
    odds() {
      // disable odd watching for now
      // this.oddsOrSpreadChanged();
    },
  },
  methods: {
    convertOdds,
    normalizeSpread,
    oddsOrSpreadChanged() {
      const self = this;
      self.changeClass = 'changed';
      setTimeout(() => {
        self.changeClass = '';
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.odds {
  color: #343a40 !important;
}
</style>
